import React from 'react';
import styled, { css } from 'styled-components';
import { Field } from 'formik';
import PropTypes from 'prop-types';

import RadioButton from './RadioButton';
import { mediaHelper } from 'utils';
import { FontWeight, Text } from 'components/Text';
import Colors from 'constants/Colors';
import ValidationError from '../ValidationError';
import Icon from '../../Icon';
import ToolTip from 'components/Tooltip';

const propTypes = {
  fieldName: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  label: PropTypes.string,
  row: PropTypes.bool,
};

const defaultProps = {
  fieldName: PropTypes.string,
  options: PropTypes.array,
  onChange: "",
  validation: true,
  label: null
};

const errorInputMixin = css`
  color: ${Colors.DANGER};
  &:focus {
    color: ${Colors.DANGER};
  }
`;

const StyledRadioButton = styled(RadioButton)`
  margin-bottom: 8px;
  &:last-child {
    margin-right: 0;
    margin-bottom: 0;
  }
  ${mediaHelper.sm`
    margin-bottom: 0;
    margin-right: 24px;
  `}

  
`;

const RadioButtonGroupContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${({row}) => row && `flex-direction: row;`}
  
  @media (max-width: 768px) {
    flex-direction: column !important;  
  }
  @media (max-width: 499px) {
    flex-direction: column !important;  
  }
`;

const RadioLabelContainer = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
`;

const RadioLabel = styled(Text).attrs({
  weight: FontWeight.Medium
})`
  font-size: 14px;
  line-height: 150%;
  //color: ${Colors.GRAY[1]};
  ${({ meta }) => (meta && meta.touched && meta.error ? errorInputMixin : "")}
`;

const RadioButtonGroup = ({
  fieldName,
  field,
  options,
  onChange,
  label,
  isRequired,
  hideLabelAsterisk,
  validationMinHeight,
  validation,
  tooltip,
  tooltipColor,
  tooltipIcon,
  form: { setFieldValue,status, setFieldTouched, touched, errors },
  ...props
}) => {
  const meta = {
    isFocused: status && status[field.name] && status[field.name].isFocused,
    touched: touched[field.name],
    error: errors[field.name]
  };


  return (
    <>
      {label && (
        <RadioLabelContainer>
          <RadioLabel
            meta={meta}
            isRequired={isRequired}
            weight={FontWeight.SemiBold}
          >
            {isRequired && !hideLabelAsterisk ? '* ' : ''}
            {label}
          </RadioLabel>
          {tooltip && <ToolTip text={tooltip} color={tooltipColor}>
            <Icon name={tooltipIcon ? tooltipIcon : "exclamation"} />
          </ToolTip>}
        </RadioLabelContainer>
      )}
      <RadioButtonGroupContainer {...props}>
        {options.map((el, index) => (
          <Field
            key={index}
            name={field.name}
            option={el.value}
            label={el.label}
            component={StyledRadioButton}
            tabIndex={el.tabIndex}
            onChange={onChange}
            value={field.value}
          />
        ))}
      </RadioButtonGroupContainer>
      {/* <ValidationError meta={meta} validationMinHeight={validationMinHeight} /> */}
      {validation && (
        <ValidationError
          meta={meta}
          validationMinHeight={validationMinHeight}
        />
      )}
    </>
  );
};

RadioButtonGroup.propTypes = propTypes;
RadioButtonGroup.defaultProps = defaultProps;

export default RadioButtonGroup;
